import {
  Flex,
  Text,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Button,
} from "@chakra-ui/react";
import PrinterIcon from "../icons/PrinterIcon";
import { CheckCircleIcon } from "@chakra-ui/icons";

export type SimpleSuccessFeedbackModalProps = {
  w?: string;
  onContinue?: () => void;
  onPrint?: () => void;
  isOpen: boolean;
};

const SimpleSuccessFeedbackModal = ({
  isOpen,
  onContinue,
  onPrint,
  w,
}: SimpleSuccessFeedbackModalProps) => {
  const handleContinue = () => {
    if (onContinue) {
      onContinue();
    }
  };
  const handlePrint = () => {
    if (onPrint) {
      onPrint();
    }
  };
  return (
    <Modal isOpen={isOpen} onClose={handleContinue} isCentered>
      <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(6.9px)" />
      <ModalContent maxW={"none"} w={w ?? "600px"}>
        <ModalBody my={4} w="100%">
          <Flex direction="column" alignItems="center" w="100%">
            <CheckCircleIcon w="24px" h="24px" color="#DCFCE7" />

            <Text lineHeight="30px" fontSize="20px" fontWeight="600" my={4}>
              Commande validée
            </Text>

            <Flex gap={4} w="100%" mt={4}>
              <Button
                variant="outline"
                w="100%"
                borderColor="brand.700"
                color="brand.700"
                onClick={handleContinue}
              >
                Continuer
              </Button>
              <Button
                variant="outline"
                w="100%"
                onClick={handlePrint}
              >
                <PrinterIcon color="gray.500" w="21px" h="21px" mr={2} />
                <Text>Voir le bon</Text>
              </Button>
            </Flex>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default SimpleSuccessFeedbackModal;
